import * as Sentry from '@sentry/react';
import { browserTracingIntegration } from '@sentry/browser';
import { replayIntegration } from '@sentry/replay';
import { logger } from './logger';

export const initSentry = () => {
  if (process.env.SENTRY_DSN) {
    Sentry.init({
      dsn: process.env.SENTRY_DSN,
      integrations: [
        browserTracingIntegration(),
        replayIntegration(),
      ],
      // Performance Monitoring
      tracesSampleRate: 0.1, // Start with 10% of transactions, tune down if hitting quota
      // Session Replay
      replaysSessionSampleRate: 0.1, // Sample rate for all sessions (10%)
      replaysOnErrorSampleRate: 1.0, // Sample rate for sessions with errors (100%)
      // Filter out noisy errors
      ignoreErrors: [
        "ResizeObserver loop limit exceeded",
        "top.GLOBALS",
        "canvas.contentDocument",
        "fb_xd_fragment",
        "bmi_SafeAddOnload",
        "EBCallBackMessageReceived",
        "conduitPage",
        "Script error.",
        "_avast_submit"
      ],
      // Strip PII before sending to Sentry
      beforeSend: (event, hint) => {
        // Don't send user email addresses
        if (event.user && event.user.email) {
          delete event.user.email;
        }
        
        // Remove authorization headers from requests
        if (event.request && event.request.headers) {
          const headers = event.request.headers;
          if (headers.Authorization) {
            delete headers.Authorization;
          }
          if (headers.authorization) {
            delete headers.authorization;
          }
        }
        
        return event;
      },
      // Use environment from Vercel
      environment: process.env.VERCEL_ENV || process.env.NODE_ENV || 'development',
      // Release information for source map association
      release: process.env.VERCEL_GIT_COMMIT_SHA || process.env.npm_package_version,
    });
  } else {
    logger.warn('Sentry DSN not provided. Error tracking is disabled.');
  }
};

export default initSentry; 